export const scenariosEnabled = () => {
  if (typeof window === 'undefined') return false
  const hostname = window.location.hostname
  return (
    (process.env.REACT_APP_DEVELOPMENT === 'true' &&
      hostname === 'dev.grile.info') ||
    ((process.env.REACT_APP_DEVELOPMENT === 'true' ||
      process.env.REACT_APP_TESTING === 'true') &&
      ['localhost', '127.0.0.1', '[::1]'].includes(hostname))
  )
}
